module.exports = __webpack_public_path__ + "img/mastercard.f7ac102f.svg";